/**
 * @author Daniel Aguirre
 * @file actions.js
 * @description EducationalElement Actions
 */

// Constants
import {
  GET_ALL_EDUCATIONAL_ELEMENTS,
  CREATE_EDUCATIONAL_ELEMENT,
  UPDATE_EDUCATIONAL_ELEMENT,
  GET_EDUCATIONAL_ELEMENT_BY_ID,
  DELETE_EDUCATIONAL_ELEMENT_BY_ID,
  GET_EDUCATIONAL_ELEMENT_BY_CATEGORY_ID
} from './constants';

/**
 * Call process to get all categories list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_EDUCATIONAL_ELEMENTS
 */
export const getEducationalElementsArray = (data, callback) => ({
  type: GET_ALL_EDUCATIONAL_ELEMENTS,
  payload: { data },
  callback
});

/**
 * Call process to get category by id
 * @param  { object } data - EducationalElement Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_EDUCATIONAL_ELEMENT_BY_ID
 */
export const getEducationalElementById = (data, callback) => ({
  type: GET_EDUCATIONAL_ELEMENT_BY_ID,
  payload: { data },
  callback
});

/**
 * Call process to get category by id
 * @param  { object } data - EducationalElement Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_EDUCATIONAL_ELEMENT_BY_CATEGORY_ID
 */
export const getEducationalElementByCategoryId = (data, callback) => ({
  type: GET_EDUCATIONAL_ELEMENT_BY_CATEGORY_ID,
  payload: { data },
  callback
});

/**
 * Call process to create category
 * @param  { object } data - EducationalElement Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of CREATE_EDUCATIONAL_ELEMENT
 */
export const createEducationalElement = (data, callback) => ({
  type: CREATE_EDUCATIONAL_ELEMENT,
  payload: { data },
  callback
});

/**
 * Call process to update category
 * @param  { object } data - EducationalElement Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPDATE_EDUCATIONAL_ELEMENT
 */
export const updateEducationalElement = (data, callback) => ({
  type: UPDATE_EDUCATIONAL_ELEMENT,
  payload: { data },
  callback
});

/**
 * Call process to delete category
 * @param  { object } data - EducationalElement Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of DELETE_EDUCATIONAL_ELEMENT_BY_ID
 */
export const deleteEducationalElementById = (data, callback) => ({
  type: DELETE_EDUCATIONAL_ELEMENT_BY_ID,
  payload: { data },
  callback
});
